import { BaseModel } from "./base-model"

export class EmployeeModel extends BaseModel {
  active: boolean = true
  lastName: string = ""
  title: string = ""
  firstName: string = ""
  number: string = ""
  socialSecurityNumber: string = ""
  telephoneCompany: string = ""

  constructor(params: any = null) {
    super(params)
    this.copyFromObject(params)
  }

  fullName() {
    return (this.firstName + " " + this.lastName).trim();
  }

  fullNameWithTelephone() {
    let fullName = this.fullName();
    let tel = this.telephoneCompany.trim();
    if (fullName == "" || tel == "") {
      return fullName + tel;
    } else
      return (this.firstName + " " + this.lastName + ", " + this.telephoneCompany).trim();
  }

  static override newModel(object: any = null) {
    return new EmployeeModel(object)
  }
}
